import { useState } from "react";

import {
    ClassificationModal,
    hasClassificationModal,
} from "./ClassificationModal";
import { Image } from "@/components/Image";
import { Classification, isListClassification } from "@/types/classification";

export const defaultBackgroundColor = "#f9f9f9";
export const defaultTextColor = "#263238";
export const defaultLightBorderColor = "#76c7c5";
export const defaultStrongBorderColor = "#009693";

type ClassificationCardProps = {
    classification: Classification;
    index?: number;
    onClick?: (classification: Classification) => void;
    variant: "buttons" | "inline" | "inline-with-names";
    isSelected?: boolean;
    state?: "enabled" | "relevantButDisabled" | "disabled" | "invalid";
};

export const ClassificationCard = ({
    classification,
    index,
    onClick,
    variant = "buttons",
    isSelected = false,
    state,
}: ClassificationCardProps) => {
    const [isClassificationModalOpen, setIsClassificationModalOpen] =
        useState(false);

    const IconComponent = classification.icon && (
        <Image
            src={classification.icon}
            alt={classification.name}
            width={35}
            priority
        />
    );

    return (
        <>
            <div className="relative">
                <div
                    onClick={
                        onClick &&
                        !(
                            state === "disabled" ||
                            state === "relevantButDisabled"
                        )
                            ? () => onClick(classification)
                            : undefined
                    }
                    className={` classification-card-${variant} ${
                        isSelected ? "selected" : ""
                    } ${
                        state === "disabled" || state === "relevantButDisabled"
                            ? "disabled"
                            : ""
                    } ${
                        state === "relevantButDisabled"
                            ? "relevantButDisabled"
                            : ""
                    } ${
                        state === "invalid"
                            ? "invalid"
                            : ""
                    }`}
                    style={{
                        ...(variant === "buttons"
                            ? {
                                  backgroundColor:
                                      classification?.background_color ||
                                      defaultBackgroundColor,
                                  color:
                                      classification?.text_color ||
                                      defaultTextColor,
                                  borderColor: isSelected
                                      ? classification?.strong_border_color ||
                                        defaultStrongBorderColor
                                      : classification?.light_border_color ||
                                        defaultLightBorderColor,
                              }
                            : {
                                  backgroundColor: "transparent",
                              }),
                    }}
                >
                    {variant !== "inline" && (
                        <div className="name-container flex-1">
                            {classification.name && (
                                <div className="name">
                                    {classification.name}
                                </div>
                            )}
                            {!isListClassification(classification.type) &&
                                classification.description && (
                                    <div className="description">
                                        {classification.description}
                                    </div>
                                )}
                        </div>
                    )}

                    {IconComponent}
                </div>

                {(hasClassificationModal(classification) ||
                    index !== undefined) && (
                    <div
                        className="absolute top-[-6px] left-[-6px]"
                        onClick={(e) => {
                            if (hasClassificationModal(classification)) {
                                e.stopPropagation();
                                e.preventDefault();
                                setIsClassificationModalOpen(
                                    !isClassificationModalOpen
                                );
                            }
                        }}
                    >
                        <div
                            className={`rounded-full w-6 h-6 flex items-center justify-center bg-[var(--secondary-color)] text-white hover:bg-[var(--primary-color)] ${
                                hasClassificationModal(classification) &&
                                "cursor-pointer"
                            }`}
                        >
                            {index !== undefined ? index : "?"}
                        </div>
                    </div>
                )}
            </div>

            {isClassificationModalOpen && (
                <ClassificationModal
                    classification={classification}
                    onClose={() => setIsClassificationModalOpen(false)}
                />
            )}
        </>
    );
};
